const translations = {
  "en": {
    "Report": "Report"
  },
  "zh-tw": {
    "Report": "報告"
  }
};

export default translations;
